import { PERMISSION_ROLE_ID_ORG_ADMIN, PERMISSION_ROLE_ID_CAREGIVER } from '@redux/person/personTypes';

/**
 * Roles allowed when creating a new team member.
 */
export const newTeamMemberRoles: { name: string; id: string }[] = [
  { name: 'Organization Admin', id: PERMISSION_ROLE_ID_ORG_ADMIN },
  { name: 'Caregiver', id: PERMISSION_ROLE_ID_CAREGIVER }
];
